import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { useRef as _, useEffect as s } from "react";
import '../../assets/PromotionBlock.css';const o = {
  "promo-image": "_promo-image_1nlw7_12",
  "promo-image__text": "_promo-image__text_1nlw7_33",
  "promo-copy": "_promo-copy_1nlw7_38",
  "promo-image--animate": "_promo-image--animate_1nlw7_44",
  "promo-slide-in-left": "_promo-slide-in-left_1nlw7_1",
  "promo-copy--animate": "_promo-copy--animate_1nlw7_51",
  "promo-slide-in-right": "_promo-slide-in-right_1nlw7_1",
  "promo-copy__header": "_promo-copy__header_1nlw7_59",
  "promo-copy__description": "_promo-copy__description_1nlw7_64",
  "promo-copy__link": "_promo-copy__link_1nlw7_65"
};
function f({ image: t, promo: r }) {
  const a = _(), n = _(), c = (i, p) => {
    i.forEach((l) => {
      l.isIntersecting && (a.current.classList.add(`${o["promo-copy--animate"]}`), n.current.classList.add(`${o["promo-image--animate"]}`), p.unobserve(n.current));
    });
  };
  return s(() => {
    const i = new IntersectionObserver(c, {
      root: null,
      rootMargin: "0px",
      threshold: 0.1
    });
    return i.observe(n.current), () => {
      i.disconnect();
    };
  }, []), /* @__PURE__ */ m("promotion-block", { children: [
    /* @__PURE__ */ m("div", { className: o["promo-image"], ref: n, children: [
      /* @__PURE__ */ e("span", { className: o["promo-image__text"], children: t.text }),
      /* @__PURE__ */ e("promo-image", { children: /* @__PURE__ */ e("a", { href: r.href, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ e("img", { src: t.url, alt: t.altText }) }) })
    ] }),
    /* @__PURE__ */ m("div", { className: o["promo-copy"], ref: a, children: [
      /* @__PURE__ */ e("h4", { className: o["promo-copy__header"], children: r.header }),
      /* @__PURE__ */ e("p", { className: o["promo-copy__description"], children: r.description }),
      /* @__PURE__ */ e("a", { className: o["promo-copy__link"], href: r.href, target: "_blank", rel: "noreferrer", children: r.linkText })
    ] })
  ] });
}
export {
  f as PromotionBlock,
  f as default
};
